import { RegistrationContext } from '@/modules/RegisterLayout/contexts/RegistrationContextProvider';
import { Typography } from '@pw-tech/omni-ui';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';
import Image from 'next/image';
import FooterPortal from '@/modules/common/Portals/FooterPortal/FooterPortal';
import { getNextStep } from '@/modules/common/utils';
const PaymentDone = () => {
  const {
    registrationDetails,
    submitRegisterForm
  } = useContext(RegistrationContext);
  const router = useRouter();
  return <article data-sentry-component="PaymentDone" data-sentry-source-file="index.tsx">
      <div className="flex flex-col gap-6">
        <Typography variant="heading3" weight="semi-bold" className="!text-2xl" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          Admission Fee
        </Typography>
        <div>
          <div className="flex gap-2 p-4 rounded-lg bg-[#DFF1E4] items-center border border-[#ADCFB7]">
            <Image src="https://static.pw.live/5eb393ee95fab7468a79d189/ADMIN/324fe557-2004-4fdc-861c-829e26e6bb1d.svg" alt="done-icon" className="rounded-full" width={28} height={28} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
            <Typography variant="regular" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
              Your payment for the registration fee has been successfully processed.
            </Typography>
          </div>
          <Typography component="div" variant="regular" className="my-5 !text-[#3D3D3D]" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
            A payment receipt has been sent to your registered email address. Please check your
            inbox for further details.
          </Typography>
        </div>

        <div className="py-2">
          <FooterPortal label="Continue" type="button" btnWrapperClass="relative sm:left-[30%]" onClick={async () => {
          await submitRegisterForm({
            step: getNextStep(router.query.step, registrationDetails?.step)
          }, true);
        }} data-sentry-element="FooterPortal" data-sentry-source-file="index.tsx" />
        </div>
      </div>
    </article>;
};
export default PaymentDone;